import API from './api';
import {
  limparSessao,
  setEmailValidaToken,
  setToken,
  setTokenRefresh
} from '../services/authentication/auth';
import { getLogin, reenviaTokenConfirmacao } from './autenticacao';

const MSG_LOGIN_ERROR = 'Usuário e/ou senha inválido';
const errorTimeout = 3000;

export const signIn = ({ login, password }) => {
  limparSessao();
  return new Promise((resolve, reject) => {
    if (!login || !password) {
      return setTimeout(() => reject(MSG_LOGIN_ERROR), errorTimeout);
    }

    const form = new URLSearchParams();
    form.append('username', login);
    form.append('password', password);
    form.append('client_id', process.env.REACT_APP_CLIENT_ID);
    form.append('client_secret', process.env.REACT_APP_CLIENT_SECRET);
    form.append('grant_type', process.env.REACT_APP_GRANT_TYPE);

    return getLogin(form)
      .then(resAuth => {
        const { access_token, expires_in, refresh_token, refresh_expires_in } = resAuth.data;

        setToken(access_token, expires_in);
        setTokenRefresh(refresh_token, refresh_expires_in);

        return resolve(true);
      })
      .catch(error => {
        let errorMessage = null;

        if (error.response) {
          errorMessage = error.response.data.error;
        }
        if (error.response && error.response.status === 401) {
          setEmailValidaToken(login);
          return reenviaTokenConfirmacao(login)
            .then(() => resolve({ usuario_validado: false }))
            .catch(err2 => {
              let errorMessage2 = null;
              if (err2.response && err2.response.data && err2.response.data.error) {
                errorMessage2 = err2.response.data.error;
              } else if (err2.response && err2.response.data && err2.response.data.errors) {
                errorMessage2 = 'Erro ao reenviar token: ';
                errorMessage2 += Object.values(err2.response.data.errors)[0][0];
                errorMessage2 += ' Favor contatar o nosso suporte e informar sobre este erro.';
              }
              limparSessao();
              return reject(errorMessage2 || MSG_LOGIN_ERROR);
            });
        }
        limparSessao();
        return reject(errorMessage || MSG_LOGIN_ERROR);
      });
  });
};

export const signOut = () =>
  new Promise(resolve => {
    window.location.replace('/force-logout');
    return resolve(true);
  });

export const refreshToken = () => API.get('/auth/refresh');

export const formatarEscopo = resEscopo => {
  let lstEscopo = resEscopo.perfil ? resEscopo.perfil : [];
  lstEscopo = lstEscopo.concat(resEscopo.complementos ? resEscopo.complementos : []);
  const escopo = {};
  lstEscopo.map(itemEscopo => {
    if (itemEscopo.tipo_chave && itemEscopo.chave) {
      const tipoChave = itemEscopo.tipo_chave.toLowerCase();
      const chave = itemEscopo.chave.toLowerCase();
      if (escopo[tipoChave] === undefined) {
        escopo[tipoChave] = {};
      }
      escopo[tipoChave][chave] = itemEscopo;
    }
    return itemEscopo;
  });
  return escopo;
};

export const resetPassword = (params, token) =>
  API.post(
    `${process.env.REACT_APP_API_CADASTRO_BASE_URL}/usuarios/authentication/nova-senha/${token}`,
    params
  );
